import { getUserInfo } from "../components/authentication/oktaConfig";

export function checkIfUserIsGlobalAccessApprover(appInfo) {
  const { employeeId } = getUserInfo();
  return appInfo?.globalAccessApprovers?.some((it) => it.employeeId === employeeId);
}

export function checkIfUserIsGlobalAccessApproverOrAccessOwner(appInfo, userId) {
  return appInfo?.globalAccessApprovers?.some((it) => it.userId === userId) ||
    appInfo?.accessOwnerList?.some((it) => it.userId === userId);
}

export function isUserGlobalAccessApprover(appInfo, userId) {
  return appInfo?.globalAccessApprovers?.some((it) => it.userId === userId);
}
